var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsingOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    iconName: "IconPersonPulseFill",
    className: "css-6xix1i",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 3c-5.28 0-9.57 4.48-9.57 10s4.29 10 9.58 10 9.58-4.48 9.58-10-4.3-10-9.58-10ZM18.2 26C7.73 26 1.93 33.92 1.93 40.44 1.92 44 3.83 44 10.54 44h8.63v-7.71c0-2.21 1.71-4 3.83-4h2.82l1.39-3.93a17.33 17.33 0 0 0-9-2.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.61 29.47A1.94 1.94 0 0 0 32.85 28c-.84-.04-1.6.49-1.89 1.3L28.5 36.3H24a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5.82c.8 0 1.52-.53 1.8-1.31l.86-2.44 2.36 8.99c.2.79.85 1.37 1.63 1.46a1.9 1.9 0 0 0 1.9-1.05l2.9-5.65H45a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-4.88c-.71 0-1.36.4-1.7 1.05l-1.16 2.28-2.65-10.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsingOff);
export default __webpack_public_path__ + "static/media/using-off.a8629b815f299576c151183aee05065f.svg";
export { ForwardRef as ReactComponent };